/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: 'transparent',
    width: '100px'
  },
  paper: {
    overflow: 'hidden',
    width: 'auto',
  },
  scrollPaper: {
    backgroundColor: 'rgba(0,0,0,0.5)'
  },
  buttonStyle: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.text.primary,
  },
  closeBtn: {
    display: 'flex',
    justifyContent: 'end',
    marginLeft: 'auto',
    marginTop: theme.spacing(-2.8),
    cursor: 'pointer',
    textAlign: 'right'
  },
  deleteButtonStyler: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.background.paper,
  },
  bold: {
    fontWeight: 500
  },
  formDialogPaper: {
    '& .MuiDialogActions-root': {
      padding: Tokens.spacing['$sp-4']
    },
    '& .MuiDialogTitle-root': {
      paddingLeft: Tokens.spacing['$sp-5-5'],
    }
  },
  closeButton: {
    display: 'flex',
    justifyContent: 'end',
    cursor: 'pointer',
    textAlign: 'right',
    marginLeft: 'auto',
  },
  dialogContent: {
    paddingBottom: Tokens.spacing['$sp-11'],
  },
  flex: {
    display: 'flex',
    fontWeight: 500
  }
}));